// import { label } from 'aws-amplify' // Removed - not needed
import React, { useEffect, useState } from 'react'
import { Pressable, Text, View } from 'react-native'
import theme from '../../../../theme'
import styles from './CustomCheckBoxStyles'

export const CustomCheckBox = ({
    options,
    defaultValue,
    onChangeSelected,
}: {
    options: Array<{ key: string; value: string }>
    defaultValue: { key: string; value: string }
    onChangeSelected: (optionValue: string) => void
}) => {
    useEffect(() => {
        setChecked(getIndex(options))
    }, [defaultValue])
    const getIndex = (options: Array<{ key: string; value: string }>) => {
        if (defaultValue == null) {
            return -1
        }
        return options.findIndex((option) => option.key === defaultValue.key)
    }
    // console.log('Test', getIndex(options))
    const [checked, setChecked] = useState<number>(-1)

    useEffect(() => {
        setChecked(getIndex(options))
    }, [options])
    // console.log('Test2', checked)
    // console.log('test3', options)

    const setChange = (index: number) => {
        // console.log("Change")
        setChecked(index)
        onChangeSelected(options[index].value)
    }
    return (
        <View style={{ flex: 1, marginHorizontal: 15 }}>
            <View style={[styles.flexDirectionRow, { gap: 20, maxWidth: '98%' }]}>
                {options.map((option, index) => {
                    const isSelected = checked === index
                    return (
                        <CustomCheckBoxItem
                            label={option.value}
                            index={index}
                            checked={isSelected}
                            onChange={() => setChange(index)}
                            key={index}
                        />
                    )
                })}
            </View>
        </View>
    )
}

export const CustomCheckBoxItem = ({
    label,
    index,
    checked,
    onChange,
}: {
    label: string
    index: number
    checked: boolean
    onChange: (index: number) => void
}) => {
    return (
        <Pressable
            style={[
                styles.containerItem,
                {
                    maxWidth: '49%',
                },
            ]}
            onPress={() => onChange(index)}
        >
            <View
                style={[
                    styles.checkboxCircle,
                    {
                        backgroundColor: checked
                            ? theme.colors.colorPrimary
                            : undefined,
                        justifyContent: 'center',
                    },
                ]}
            >
                {checked && (
                    <View
                        style={{
                            alignSelf: 'center',

                            width: 10,
                            height: 10,
                            borderColor: 'white',
                            borderWidth: 1.5,
                            borderRadius: 20,
                        }}
                    />
                )}
            </View>

            <Text
                style={[
                    styles.item,
                    {
                        color: checked
                            ? theme.colors.colorPrimary
                            : theme.colors.textSecondary,
                        flexShrink: 1,
                    },
                ]}
            >
                {label}
            </Text>
        </Pressable>
    )
}
